<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<div class="illustype_fullpage_image_text"><div class="fullpage_image_text"><img alt="e9781466821378_i0002.jpg" src="e9781466821378_i0002.jpg"/></div>
</div>
<div class="illustype_fullpage_image_text"><div class="fullpage_image_text"><img alt="e9781466821378_i0003.jpg" src="e9781466821378_i0003.jpg"/></div>
</div>
<div class="illustype_image_externe"><div class="image_externe"><img alt="e9781466821378_i0004.jpg" src="e9781466821378_i0004.jpg"/></div>
</div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781466821378_fm03.vue?9a5dbe10